
// NATIVE 


// INSTALLED 


// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { updateAvatarEmployeeService, uploadFileImageFromCameraService, uploadFileImageService, uploadFilePdfService, changeAvatarService } from '../../services/uploaders.service';
import { types } from '../../commons/types/types';
import { storageGetCurrentUser } from '../../commons/utils';
import { updatePhotoURL } from '../auth/authSlice';




export const uploadPdfStore = ( code_file:string, file_rut:any, setPercentageUploadRut:any): any => {
    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result =  await uploadFilePdfService(code_file, file_rut, setPercentageUploadRut);

        dispatch( unCheckingPreload() );

        return result;
        
    }
}


export const uploadImgStore = ( code_file:string, file_rut:any, setPercentageUploadRut:any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result = await uploadFileImageService(code_file, file_rut, setPercentageUploadRut);

        dispatch( unCheckingPreload() );


        return result;
        
    }
}




export const uploadFileImageFromCamera = ( code_file:string, blob:any, setPercentageUpload:any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result = await uploadFileImageFromCameraService(code_file, blob, setPercentageUpload);

        dispatch( unCheckingPreload() );


        return result;
        
    }
}


export const updateAvatarEmployeeStore = ( code_file: string, idEmployee:string, blob:any, setPercentageUpload:any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result = await updateAvatarEmployeeService(code_file, idEmployee, blob, setPercentageUpload);

        dispatch( unCheckingPreload() );


        return result;
    }
}

export const changeAvatarStore = ( code_file: string, file: any ): any => {
    return async( dispatch: any ) => {
        dispatch( checkingPreload() );
        const result = await changeAvatarService(code_file, file);

        if(result.ok){
            const { avatar } = result.data; 
            const user_storage = await storageGetCurrentUser();
            await window.localStorage.setItem(types.storage.userStorage, JSON.stringify({ ...user_storage, photoURL: avatar }));
            dispatch(updatePhotoURL(avatar));
        }
        dispatch( unCheckingPreload() );
        return result;
    }
}